export default {
  "": "If the loan exceeds the repayment period, your borrowed asset will incur three (3) times the interest during the overdue period. In case of a delay exceeding {'{'}{hour}{'}'} hours, your collateral assets will be liquidated to repay the borrowed amount and interest.",
  "action": "Action",
  "AddLoan": "Increase",
  "AdjustLoanFail": "Fail to adjust the collateral amount. Please try again later. ",
  "all": "All",
  "applicationRecords": "Application Records",
  "apply": "Apply",
  "appResultThen": "for updates.",
  "approvalInProgress": "Approval in Progress",
  "assets": "Coin",
  "available": "Available",
  "availableAssetsNewTips": "Available Equity: <span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">Transfer</a> or <a href=\"javascript:;\" class={depositClass} id=\"deposit\">Deposit</a>",
  "balance": "Available Balance",
  "BorrowableAmountNewTips": "Borrowable Amt: {amount} {coin} to",
  "borrowAmountNotZero": "The Borrowed amount cannot be 0.  \n",
  "borrowingAccount": "Borrowing Account",
  "borrowingLimit": "Borrowing Limit",
  "botValidateErrCode101": "The minimum price is too low",
  "botValidateErrCode102": "The minimum price is too high",
  "botValidateErrCode103": "The maximum price is too low",
  "botValidateErrCode104": "The maximum price is too high",
  "botValidateErrCode105": "There are too few grids",
  "botValidateErrCode106": "There are too many grids",
  "botValidateErrCode107": "The investment amount is too low and does not meet the investment requirement",
  "botValidateErrCode108": "The investment amount is too high and exceeds the contract investment limit",
  "botValidateErrCode109": "The take-profit price is too low",
  "botValidateErrCode110": "The take-profit price is too high",
  "botValidateErrCode111": "The stop-loss price is too low",
  "botValidateErrCode112": "The stop-loss price is too high",
  "botValidateErrCode113": "The entry price is too low",
  "botValidateErrCode114": "The entry price is too high",
  "cancel": "No",
  "cancelAll": "Cancel All",
  "cancelOrder": "Cancel",
  "chooseVipCryptoLoans": "Opt for VIP Crypto Loans to enjoy higher borrowing limits. Your borrowing capacity increases with your Spot or Derivatives trading volume.  ",
  "close": "Close",
  "coin": "Coin",
  "collateralAccount": "Collateral Account",
  "confirm": "Yes",
  "contactOnline": "Contact Support",
  "contract_account": "Derivatives account",
  "createErrorCode400": "The data sent by the user contains illegal parameters. Please check the error message and error details for more information.",
  "createErrorCode401": "Insufficient balance.",
  "createErrorCode402": "The number of bots created by the user has reached the limit.",
  "createErrorCode403": "FORBIDDEN",
  "createErrorCode404": "The requested resource was not found.",
  "createErrorCode407": "This user type does not support the creation of Grid Bot Subaccounts.",
  "createErrorCode408": "Duplicate regular investment tokens have been selected",
  "createErrorCode409": "Invalid maximum investment amount",
  "createErrorCode410": "Invalid maximum investment amount",
  "createErrorCode411": "The bot has been terminated",
  "createErrorCode412": "The Unified Margin Account is being upgraded",
  "createErrorCode500": "Internal Server Error",
  "createErrorCode501": "Internal Processing Timeout",
  "createErrorCode503": "The DCA Bot cannot be closed at the moment and may be in the process of making a buy transaction",
  "createTimes": "Date/Time",
  "currency": "Coins",
  "currentOperationFailed": "Failed! Please try again.",
  "dailyRate": "Daily Interest Rate",
  "dedAccManager": "Dedicated Account Manager",
  "deposit": "Deposit",
  "detail": "Details",
  "direction": "Direction",
  "earnSummary": "Summary",
  "end": "End Time",
  "enjoyPersonalizedVipLoan": "Enjoy the personalized touch with VIP Crypto Loans — your dedicated account manager will tailor loan amounts to meet your specific needs and help determine the most suitable loan term.",
  "enterQuantity": "Please enter the quantity",
  "EstimatedDailyInterest": "Est. Daily Interest",
  "exceedLimitError": "You've exceeded the platform's borrowing and collateral limits.",
  "exceedPlatformBorrowLimit": "You've exceeded the platform's borrowing limit.",
  "exceedPlatformLimit": "You've exceeded the platform's collateral limit.",
  "expiryDate": "Expiry Date",
  "failed": "Failed",
  "FAQNewTips": "You may borrow from Bybit Loans if you are a registered Bybit user and have assets in your Funding or Unified Trading Account. ",
  "fiat": "Fiat",
  "filter": "Filters",
  "firstPage": "Main Page",
  "fixedRateLoan": "Fixed Rate Loan",
  "fixedRateTerm": "Fixed Rate/Term",
  "from": "Start Time",
  "fullRepaymentAssetReturn": "After full repayment, collateral will be transferred back to your ",
  "funding": "Funding",
  "getHightLoanAmount": "Unlock higher limits",
  "global_setting_quick_order_desc": "<p>1.Market Order (Quick Order Placement)</p>\n<p>2.Please note that your filled buy quantity may differ slightly from the order quantity you’ve entered.</p>",
  "global_setting_quick_order_label": "Quick Order Placement",
  "global_setting_title": "Customized Settings (Apply to Spot)",
  "gotIt": "Got It",
  "hint": "Reminder",
  "hourlyAnnualIntRate": "Hourly/Annual Interest Rate",
  "HourlyAnnualizedInterestRate": "Hourly/Annual Interest Rate",
  "hoursAmountTips": "The minimum hourly interest rate is {amount} {coin}. Note: Interest is calculated on an hourly basis, and any period less than one (1) hour will be rounded up to one (1) hour.",
  "idAuth": "Verify Now",
  "iKnow": "Got It",
  "innovateQuota": "Available Quota",
  "inProgress": "In Progress",
  "InsufficientAvailableAssetsTips": "Insufficient collateral. Account Balance: {num} {token}. Please <a href=\"javascript:;\" class={transferClass} id=\"transfer\">transfer</a> or <a href=\"javascript:;\" class={depositClass} id=\"Deposit\">deposit</a>. ",
  "insufficientLendingPoolDemand": "Due to high demand for borrowing, the funding pool is currently limited. Thank you for your patience.",
  "interestRatesHourlyYearly": "Interest rates (hourly / yearly)",
  "introUTAUMA": "Unified Trading",
  "kline": "Chart",
  "lastSixMonthsCommissionRecords": "Only show order history in the past six months",
  "lendingAnnouncements": "Integration of Lending Into Flexible Savings",
  "leverage": "Leverage",
  "leverage_off_trade_tip": "Please turn on leverage and then trade with leverage.",
  "leverageCloseErrInfo": "Failed! Please complete all repayments before turning off Margin Trading.",
  "leverageCloseTips": "Failed to disable Margin Trading, as there are active Spot Margin orders in your account.",
  "leverageLoanTips": "This action could not be completed as your Unified Margin Account's IM/MM utilization rate has exceeded the threshold.",
  "leverageTryAgain": "System error. Please try again later.",
  "limitGreaterNoNeedRequest": "You don't need to submit a request, as your borrowing limit exceeds the amount you wish to borrow.",
  "liquidate": "Liquidated",
  "liquidationErrorInfo": "Failed! Liquidation has been triggered on your account.",
  "LiquidationPrice": "Liquidation Price",
  "loan": "Borrow",
  "loan_accont_assets_tip": "Insufficient Available Balance",
  "loan_account_tip": "Sorry, your account is restricted for security reasons and you are currently unable to access Crypto Loans. Please contact our online customer service if you have any questions.",
  "loan_agreement": "I agree to the <a href={url} target=\"_blank\" class={className}>Crypto Loans Service Agreement</a>",
  "loan_all_order": "All Loans",
  "loan_amount": "Max. Borrowing Amount",
  "loan_amount_less_tip": "Due to overwhelming borrowing demand, there are insufficient loanable assets available at the moment. Please reduce your loan amount, or try again tomorrow",
  "loan_amount_pledge_less_tip": "Due to overwhelming borrowing demand, the amount that can be put up as collateralpledged for loans is limited at the moment. Please reduce your collateralpledge amount, or try again tomorrow.",
  "loan_apply": "Apply for a Crypto Loan",
  "loan_apply_time": "Time of Borrowing",
  "loan_assets_debt": "Account Overview",
  "loan_assets_transfer": "Transfer of borrowed assets to:",
  "loan_assets_transfer_layer": "The borrowed assets will be transferred to {account}",
  "loan_assets_transfer_tip": "The borrowed amount will be automatically transferred to the corresponding account",
  "loan_available_funding_tip": "Available Qty (Funding): <span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">Transfer</a> or <a href=\"javascript:;\" class={depositClass} id=\"deposit\">Deposit</a>",
  "loan_available_funding_tip_new": "Available Funding:<span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">Transfer</a> or <a href=\"javascript:;\" class={depositClass} id=\"deposit\">Deposit</a>\"",
  "loan_available_spot_assets": "Available Spot Assets",
  "loan_available_spot_less": "Insufficient Spot assets. Balance {num} {token}. Please<a href=\"javascript:;\" class={transferClass} id=\"transfer\"> Transfer </a>or<a href=\"javascript:;\" class={depositClass} id=\"Deposit\"> Deposit</a>.",
  "loan_available_spot_tip": "Available Spot assets:<span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">Transfer</a>or<a href=\"javascript:;\" class={depositClass} id=\"deposit\">Recharge</a>",
  "loan_available_spot_tip_new": "Available Spot:<span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">Transfer</a> or <a href=\"javascript:;\" class={depositClass} id=\"deposit\">Deposit</a>",
  "loan_back_assets": "Collateral Returned to Your Spot Account",
  "loan_borrow_tips": "*Borrowed Assets will be transferred to your Funding Account.",
  "loan_confirm_amount": "Loan Amount",
  "loan_confirm_order": "Confirm Details",
  "loan_confirm_tips": "*Borrowed Assets will be transferred to your Funding Account.",
  "loan_cope_interest": "Outstanding Interest",
  "loan_cope_principal": "Outstanding Principal",
  "loan_cope_total": "Total Outstanding",
  "loan_covering_position_tip": "Unable to make a payment when the collateral amount is being adjusted.",
  "loan_currency": "Coin to Borrow",
  "loan_debt_assets": "Coin(s) Borrowed",
  "loan_debt_total": "Total Outstanding",
  "loan_edit_pledge_amount": "Adjust Collateral Amount",
  "loan_exceed_pledge_rate_tip": "The loan request is declined as the LTV will exceed the Margin Call ratio if the loan is approved.",
  "loan_failed": "Failed",
  "loan_high_exchange_rate": "High Loan-to-Value (LTV)",
  "loan_high_risk": "high risk",
  "loan_hour_day_rate": "Hourly Interest Rate/Daily Interest Rate",
  "loan_hour_day_rate_tip": "Minimum interest accrued per hour is {precision} {token}. <br />\n\nDaily Interest Rate: {dayRate}<br />\nAnnual Interest Rate: {yearRate}<br />\n\nNote: Interest is calculated hourly, in which less than one hour is calculated as one hour.",
  "loan_init_ltv": "Initial LTV",
  "loan_init_ltv_tip": "The Initial LTV ratio determines the initial amount of coins that can be borrowed. The initial LTV ratio may vary for different collateral.",
  "loan_init_ltv_title": "Initial Loan-to-Value Ratio (LTV)",
  "loan_input_amount": "Enter the loan amount you would like to borrow",
  "loan_input_pledge_amount": "Enter the amount of collateral you would like to put up",
  "loan_instant_credit": "Receive borrowed assets instantly",
  "loan_interest_accruing": "Interest Calculation in Progress",
  "loan_interest_accruing_tip": "Interest calculation is in progress. Unable to make a payment.",
  "loan_interest_rate": "Interest Rate",
  "loan_interest_time": "Interest Accrual Period",
  "loan_interest_time_unit": "{num} Hour(s)",
  "loan_kyc_tip": "Please complete your KYC Lv. 1 verification before creating a Crypto Loan request.",
  "loan_limit": "Loan Term",
  "loan_limit_day": "{num} Days",
  "loan_limit_tip": "Interest is calculated on an hourly basis. Borrowed coins can be returned at any time before the due date. You’ll be charged {multiple} times the hourly interest during the overdue period. Your collateral will be liquidated to repay a loan and the interest if you fail to make the repayment {time} hours after the due time.",
  "loan_limit_tip_new": "If the loan is not repaid within the repayment period, the borrowed asset will accrue interest at ({num}) times the normal interest rate during the overdue period. In case of a delay exceeding {hour} hours, your collateral assets will be liquidated to repay the borrowed amount and interest.",
  "loan_liquidate_ltv": "Liquidation LTV",
  "loan_liquidate_ltv_tip": "If the LTV ratio (Loan Amount/Collateral Amount) reaches the threshold, Bybit will liquidate your collateral assets to repay your loan and interest in full.",
  "loan_liquidate_pledge_tip": "Liquidating. Unable to adjust the collateral amount.",
  "loan_liquidate_tip": "Liquidating. Unable to make a payment.",
  "loan_liquidation": "Liquidating",
  "loan_liquidation_price": "Liquidation Price",
  "loan_login": "Log in First to Borrow",
  "loan_login_tip": "Please <a href={loginUrl} class={loginClass}>log in</a> or <a href={registerUrl} class={registerClass}>register</a> first to take out a loan.",
  "loan_low_risk": "low risk",
  "loan_lt_user_tip": "Note: Crypto loans may have an impact on your Institutional Lending LTV.",
  "loan_manual": "Manual",
  "loan_max_amount": "Max. Amount: {num} {token}",
  "loan_max_amount_tip": "Unable to borrow as the max. borrowing amount has been reached.",
  "loan_max_amount_tip2": "Your {coin} loan amount will exceed the maximum loan amount of {num} {coin}. Please reduce the loan amount or make a repayment.",
  "loan_max_pledge_tip": "Unable to borrow as the upper limit for the collateral amount has been reached.",
  "loan_max_pledge_tip2": "Your {coin} pledge amount will exceed the maximum pledge amount of {num} {coin}. Please reduce your pledge amount or make a repayment.\nYou may not put up more {coin} collateral than the maximum of {num} {coin}. Please reduce your collateral amount accordingly.",
  "loan_middle_risk": "medium risk",
  "loan_min_amount": "Min. Amount: {num} {token}",
  "loan_min_amount_tip": "Unable to borrow as the loan amount entered for the coin is smaller than the min. amount required.",
  "loan_min_pledge_amount_tip": "Unable to borrow as the collateral amount entered for the coin is smaller than the min. amount required.",
  "loan_min_pledge_tip": "The min. adjustment amount allowed is {num} {token}.",
  "loan_no_order_tip": "You don't currently have any outstanding loans. Apply now for a <span>Crypto Loan</span>.",
  "loan_no_pledge_tip": "You don't currently have any outstanding loans. Apply now for a <span>Crypto Loan</span>.",
  "loan_now": "Borrow Now",
  "loan_order": "Borrowings and Repayments",
  "loan_order_number": "Loan No.",
  "loan_over_capital": "Principal Balance",
  "loan_over_interest": "Interest Balance",
  "loan_overdue": "Past Due",
  "loan_paid_off": "Repaid",
  "loan_pledge": "Crypto Loans",
  "loan_pledge_amount": "Collateral Amount",
  "loan_pledge_assets": "Collateral Coin(s)",
  "loan_pledge_deposit": "Collateral Amount",
  "loan_pledge_desc": "Borrow one type of crypto asset using another one as collateral. The borrowed assets can be traded on Bybit's Spot and Derivatives markets, used on Earn and other platforms, or withdrawn.",
  "loan_pledge_failed": "Failed to Adjust the LTV",
  "loan_pledge_processing": "LTV Adjustment in Progress",
  "loan_pledge_rate_after": "LTV After",
  "loan_pledge_rate_current": "Current LTV",
  "loan_pledge_rate_success": "Collateral Amount Adjusted",
  "loan_pledge_rate_success_tip": "You have increased the collateral amount by {num} {token} and the adjusted LTV ratio is {rate}.",
  "loan_pledge_rate_success_tip1": "You have successfully reduced your collateral by {num} {token}. Your new LTV is {ltv}.\n",
  "loan_pledge_rate_tip": "The loan-to-value (LTV) is the ratio of your loan amount to the value of your collateralized coins. <br />\n\nInitial LTV: <span class=\"init\">{ltv1}%</span><br />\n\nThe initial loan-to-value (LTV) is the ratio between the value of assets that can be borrowed and the value of your collateralized coins. <br />\n\nMargin Call LTV: <span class=\"warning\">{ltv2}%</span><br />\nIf the LTV ratio (Loan Amount/Collateral Amount) reaches the threshold, you will be required to add more collateral to your loan. <br />\n\nLiquidation LTV: <span class=\"liquidate\">{ltv3}%</span><br />\nIf the LTV ratio (Loan Amount/Collateral Amount) reaches the threshold, Bybit will liquidate your collateral assets to repay your loan and interest in full.",
  "loan_pledge_total": "Total Collateral Value",
  "loan_pledge_total_amount": "Total Collateral",
  "loan_process": "How It Works",
  "loan_processing": "Loan Request in Progress",
  "loan_progress_order": "Borrowings",
  "loan_progress_order_qty": "My Borrowings ({num}）",
  "loan_question1_title": "What are the requirements for using the Crypto Loans service?",
  "loan_question2_detail": "Interest is calculated hourly, where loans that are less than one hour will be calculated as one hour. Interest will start to accrue at the time of borrowing.\n\nNote: Interest is calculated based on the loan interest rate displayed at the time of borrowing.\n\nInterest = Borrowed amount × Hourly interest rate",
  "loan_question2_title": "How is loan interest calculated?",
  "loan_question3_detail": "Yes, you can repay any time prior to the due date with no penalty fees. Once you return the loan amount, we’ll only charge an interest fee based on the number of hours borrowed.",
  "loan_question3_detail2": "As long as you are registered with Bybit and have funds available as collateral in your Spot or Funding account, you can borrow coins on Bybit.",
  "loan_question3_title": "Can I repay all or part of my loan in advance?",
  "loan_question4_detail": "The loan-to-value (LTV) refers to the ratio of your loan amount to the value of your collateralized coins. \n\nThe ratio is calculated as follows:\n\nLTV = Loan Amount/ Collateral Amount\n\nLoan Amount = (Outstanding Principal + Outstanding Interest + Outstanding Overdue Interest)",
  "loan_question4_title": "What is the loan-to-value (LTV) ratio?",
  "loan_question5_content": "You can adjust the collateral amount on the Order page. Also, you can always add more collateral to lower the loan-to-value (LTV) ratio.",
  "loan_question5_title": "How do I adjust the collateral amount?",
  "loan_question6_content": "Crypto loans can also be used for advanced strategies such as crypto yield arbitrage, a strategy that involves finding a platform where you can borrow a cryptocurrency at a lower interest rate and lend it at a higher interest rate on another platform.\n\n<a href={url} target=\"_blank\">Click to learn more</a>.",
  "loan_question6_title": "Can crypto loans be used for other strategies such as arbitrage?",
  "loan_question7_content": "Crypto loans be used for investments in Earn products, DeFi yield-farming and even margin trading, in which you can use borrowed assets to expand the margin availability and avoid being liquidated on your leveraged positions.\n\n<a href={url} target=\"_blank\">Click to learn more</a>.",
  "loan_question7_title": "How can crypto loans be used?",
  "loan_received": "Receive Borrowed Funds",
  "loan_repay_account_tip": "Upon full repayment, your collateral will be transferred back to your Spot account",
  "loan_repay_anytime": "Repay at any time with no penalties",
  "loan_repay_failed": "Failed to Make the Payment",
  "loan_repay_interest": "Repay Principal and Interest",
  "loan_repay_min_amount": "Min. Repayment Amount Required: {num} {token}",
  "loan_repay_more_tip": "The repayment amount entered has exceeded the total outstanding balance.",
  "loan_repay_processing": "Payment in Progress",
  "loan_repay_success": "Payment Successful",
  "loan_repay_success_tip": "You have just repaid {num} {token}.",
  "loan_repay_time": "Repayment Time",
  "loan_repay_time_new": "Repayment Time",
  "loan_repay_tips": "* Upon full repayment, your collateral will be transferred back to your Funding Account",
  "loan_spot_account": "Spot account",
  "loan_spot_assets_not_enough": "Insufficient Spot assets. Please proceed to<a href=\"javascript:;\" class={transferClass} id=\"transfer\">Transfer</a>or<a href=\"javascript:;\" class={depositClass} id=\"deposit\">Deposit</a>",
  "loan_submember_tip": "You cannot take out Crypto Loans with a Subaccount.",
  "loan_success": "Borrowing Successful",
  "loan_success_tip": "You have successfully borrowed {num} {token}.",
  "loan_total_amount": "Total Repayable Amount",
  "loan_total_interest": "Total Interest",
  "loan_total_interest_new": "Est. Total Interest",
  "loan_total_repay": "Total Repayment Amount",
  "loan_total_repayment": "Total to Repay",
  "loan_total_repayment_new": "Est. Total Repayment Amount",
  "loan_type": "Type",
  "loan_user_manual": "User Guide",
  "loan_uta_tip1": "You have migrated your Spot Account functions to your Funding Account, and will no longer be able to use your Spot Account for Crypto Loans. We will make an announcement when Crypto Loans become available via the Funding Account.",
  "loan_uta_tip2": "New loans will be available after your Unified Trading Account upgrade is complete.",
  "loan_uta_tip3": "You have migrated your Spot Account functions to your Funding Account, and will no longer be able to make collateral adjustments for crypto loans. We will make an announcement when Crypto Loans become available via the Funding Account.",
  "loan_uta_tip4": "Collateral adjustments will be available after your Unified Trading Account upgrade is complete.",
  "loan_uta_tip5": "Repayments will be available after your Unified Trading Account upgrade is complete.",
  "loan_valuation": "Est. Value ({token})",
  "loan_video_btn": "Video Tutorials",
  "loan_video_title": "Introduction to Crypto Loans (Video)",
  "loan_want": "Amount to Borrow",
  "loan_warning_ltv": "Margin Call LTV",
  "loan_warning_ltv_tip": "If the LTV ratio (Loan Amount/Collateral Amount) reaches the threshold, you will be required to add more collateral to your loan.",
  "LoanAccountID": "Contact Info (For Us to Reach You)",
  "LoanAccountNumber": "Please make sure to include the country code as well.",
  "loanAmount": "Loan Amount",
  "LoanAmountNew": "Available Loan Amount: {amount} {coin}  From {currentAmount}",
  "LoanAmountNew1": "Borrowing Limits: {minAmount}-{maxAmount} {coin}",
  "LoanAmountNewPledge": "Available Collateral Amount: {amount} {coin} From {currentAmount} <a href=\"javascript:;\" class={transferClass} id=\"transfer\">Transfer</a> or <a href=\"javascript:;\" class={depositClass} id=\"Deposit\">Deposit</a>",
  "LoanAmountNewPledge1": "Collateral Limits: {minAmount}-{maxAmount} {coin}",
  "LoanEmailTips": "Please provide valid contact details.",
  "LoanInterestRecords": "Interest History",
  "LoanInterestRecordsTips": "Hourly interest recording is exclusive to Flexible Crypto Loans.",
  "loanLualityDeposit1": "You can only reduce your collateral amount when the current LTV ratio is lower than the Initial LTV. ",
  "loanLualityDeposit2": "The maximum reduction in collateral is the amount needed to bring the LTV ratio back to its initial level.",
  "loanLualityDeposit3": "The collateral amount cannot be reduced if the value of reduced amount is lower than that of the adjustable margin.",
  "LoanMinAmount": "Min. Subscription Qty. {amount}",
  "LoanMinAmountNew": "Min. Borrowing Amount:",
  "LoanMinAmountTips": "Subscriptions can only be made for quantities exceeding the minimum subscription amount.",
  "LoanRateTips1": "Flexible Crypto Loans offer an hourly floating interest rate, calculated based on the actual borrowing time per hour, with the option for early repayment.",
  "loanRecommend": "Recommended",
  "loanSureTips": "Check the \"I agree\" box before proceeding to confirm",
  "loanTime": "Timestamp",
  "loanType": "Type",
  "login": "Log In",
  "ltvAfterBorrowing": "LTV After Borrowing",
  "ltvExceedInitial": "The LTV After Borrow cannot exceed the Initial LTV of {num1}%.",
  "ltvRatio": "Crypto Loans Data",
  "marginCallLtvRat": "Margin Call LTV Ratio",
  "MARKET": "Market Price",
  "max": "Maximum",
  "maxBorrowAmount": "Max. Borrowing Limit",
  "maxBorrowingLimit": "Max. Borrowing Limit",
  "minHourlyIntRate": "The minimum hourly interest is 0.00000001 USDT.",
  "more": "More",
  "myLimit": "My Limit",
  "network_error": "Request failed. Please try again later.",
  "NEW": "Active",
  "nextPage": "Next Page",
  "none": "None",
  "noRecords": "No Records Found",
  "noteSystemCalculates": "Note: The system calculates interest on an hourly basis and counts any duration less than one hour as one full hour.",
  "OnlyDepositTransfer": "<a href=\"javascript:;\" class={transferClass} id=\"transfer\">Transfer</a> or <a href=\"javascript:;\" class={depositClass} id=\"Deposit\">Deposit</a>",
  "onlyVipCanApply": "Only VIP users are eligible to apply.",
  "operationSuccess": "Success",
  "or": "or",
  "orderBook": "Order Book",
  "orderHistory": "Order History",
  "orderId": "Order ID",
  "orderType": "Order Type",
  "orLoan": "or",
  "otcErrorInfo": "Oops, you've already enabled Institutional Lending, and are no longer eligible for Margin Trading.",
  "otcFlexible": "Flexible",
  "other": "Other",
  "outstanding": "Outstanding",
  "pauseTradeTip": "{symbol} is currently not available for trades. For more information, please refer to our<a href={url} target=\"_blank\">blog</a>.",
  "pendingOrderReapply": "You have an order processing. Please wait until it's done before placing another.  ",
  "personalizedLoanAmt": "Personalized Loan Amount",
  "pleaseSelect": "Please select",
  "PledgableLimitNewTips": "Collateral Amt: {amount} {coin} from",
  "prevPage": "Previous Page",
  "price": "Price",
  "quantity": "Qty",
  "reachedAccountLimit": "You've reached your account limit. ",
  "reachedPlatformLimit": "You've reached the platform limit. ",
  "reachOutContactDetails": "We will reach out to you using the contact details provided within one (1) working day. ",
  "receivedApplication": "We've received your application. You may submit it again later. ",
  "ReduceLoan": "Decrease",
  "ReduceLoanAssets": "Reduce Collateral Amount",
  "ReduceLoanAssetsNew": "Withdrawable Collateral Amount:<span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">Transfer</a> or <a href=\"javascript:;\" class={depositClass} id=\"deposit\">Deposit</a>",
  "ReduceLoanTip1": "The collateral amount cannot be reduced unless the current LTV ratio is lower than the Initial LTV.  ",
  "ReduceLoanTip2": "The collateral amount cannot be reduced unless the value of the reduced amount is lower than that of the adjustable margin.",
  "ReduceLoanTip3": "The collateral amount cannot be reduced if the current LTV ratio meets or exceeds the initial LTV ratio. Please try again. ",
  "ReduceLoanTip4": "You can manage the collateral amount on the Order page. You can increase your collateral at any time and decrease it only when the current LTV ratio is lower than the Initial LTV. ",
  "reducePledgeAssetsTransferBack": "Withdrawn collateral will be transferred to:",
  "remainingCollateralLimit": "Remaining Collateral Limit",
  "remainingLimit": "Remaining Limit",
  "repayment": "Repay",
  "reset": "Reset",
  "resetNew": "Reset",
  "result_not_found": "No Records Found",
  "reverse_contract_account": "Inverse Derivatives account",
  "reviewExpectedTime": "The review is expected to be completed in 5 minutes. Please check {resultLink}   ",
  "riskWarning": "Confirmation",
  "sameLimitDontRepeat": "Your borrowing limit equals your current application. Please avoid reapplying.",
  "search": "Search",
  "searchNew": "Search",
  "side": "Direction",
  "signalStatusExpired": "Expired",
  "sns": "Social Media Platforms",
  "spot_account": "Spot Account",
  "state": "Status",
  "status": "Status",
  "stethTradeTipText": "You will be able to earn daily yield on any stETH held as collateral in Crypto Loans.",
  "stop_limit": "TP/SL",
  "stop_limit_tips_2": "Margin Trading cannot be activated if you have a Take-Profit or Stop-Loss order in place.",
  "submitApplicationLimit": "You can submit your application up to three (3) times a day. Please submit your application again tomorrow.",
  "submittedSuccessfully": "Submitted successfully",
  "success": "Success",
  "successfully": "Success",
  "sure": "sure",
  "tailoredLoanTerm": "Tailored Loan Term",
  "thanksForInterestVip": "Thank you for your interest in VIP Crypto Loans.",
  "times": "times",
  "timestamp": "Timestamp",
  "title_404": "404 {'|'} Bybit Spot Trading  ",
  "to": "To",
  "toastTheSymbolNotExist": "Oops, the Spot pair you've selected is currently not available for trades.",
  "total": "Total",
  "totalInterest": "Total Interest",
  "tradeDetails": "Order Details",
  "tradeId": "Transaction ID",
  "transfer": "Transfer",
  "uid": "Your Account ID (For us to reach you)",
  "undefined": "undefined",
  "unifiedAccount": "Unified Trading Account",
  "usdc_contract_account": "USDC Derivatives account",
  "useMainUidToApply": "Please make sure to apply using the main UID.",
  "variableCannotBeEmpty": "{variable} cannot be empty.",
  "vipCryptoLoans": "VIP Crypto Loans",
  "vipExclusive": "VIP Exclusive",
  "vipLoan": "VIP Crypto Loans",
  "vipLoan1": "VIP Crypto Loans",
  "vipLoanBorrowLimitExpire": "【Bybit】VIP Crypto Loans Borrowing Limit Expiration Notice\n\nHello.\nThe VIP borrowing limit you applied for has expired, if you need to apply again, please also go to VIP Pledge Borrowing Application;\nCoin Type: {'{'}{coin}{'}'}\nRequested amount: {'{'}{num}{'}'} {'{'}{coin}{'}'}\nExpiration date: {'{'}{date}{'}'}\n\n\nBybit Team\nPlease do not reply to system emails.",
  "vipLoanBorrowLimitNotif": "Title\nVIP Crypto Loans: Borrowing Limit Application Approved\n\nContent\nDear Trader,\n\nWe’re pleased to inform you that your application for a borrowing limit has been approved. Please make sure to use your approved limit before it expires.\n\nDetails of your application:\nCoin: {'{'}{coin}{'}'}\nApproved Borrowing Limit: {'{'}{num}{'}'} {'{'}{coin}{'}'}\nExpiration Date: {'{'}{date}{'}'}\n\nThank you for choosing Bybit.\n\nBest regards,\nThe Bybit Team\n\nPlease do not reply to this automated email.",
  "vipLoanBorrowLimitRemind": "【Bybit】VIP Crypto Loans Borrowing Limit Expiry Reminder Notice\n\nHello.\nYou have {'{'}{days}{'}'} days left for the VIP borrowing limit you applied for, please use the limit to borrow as soon as possible;\nCurrency applied for: {'{'}{coin}{'}'}\nRequested amount:  {'{'}{num}{'}'}  {'{'}{coin}{'}'}\nExpiration date: {'{'}{date}{'}'}\n\n\nBybit Team\nPlease do not reply to the system email.",
  "vipLowerInterestRate": "Enjoy lower interest rates as a VIP user.",
  "vipThresholdRights": "Click here to learn about VIP eligibility criteria and exclusive benefits.",
  "yearlyInterestRate": "Yearly Interest Rate",
  "yearlyInterestRateNew": "Annual Interest Rate"
}